













import {Component, Vue, Prop} from 'vue-property-decorator'

@Component({})

export default class LoaderButton extends Vue {
  @Prop({type: String, default: ''}) public buttonClass!: string
  @Prop({type: Boolean, default: false}) public loading!: boolean
  @Prop({type: String, default: 'button'}) public type!: string

  public click() {
    if (!this.loading) {
      this.$emit('click-button')
    }
  }
}
